import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = "ews_sid";

function sessionId() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(36).slice(2);
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    axios.post(`${API}/track`, {
      path: pathname,
      referrer: document.referrer || "",
      session_id: sessionId(),
    }).catch(() => {});
  }, [pathname]);
  return null;
}
